<template>
    <div>
        <template v-if="actions.length > 0">
            <b-table bordered striped hover :items="actions" :fields="actionFields" v-if="view == 'table'" show-empty :responsive="true">
                <template v-slot:cell(corrective_action_id)="data">
                    <span style="white-space: nowrap;">
                        <router-link :to="`/corrective-actions/view/${data.item.corrective_action_id}`" class="btn btn-sm btn-light mr-1 mb-xl-0 mb-lg-2 mb-0 d-xl-inline d-lg-block d-inline">
                            <i class="fa fa-eye"></i> View
                        </router-link>
                        <!-- <router-link :to="`/corrective-actions/edit/${data.item.corrective_action_id}`">Edit</router-link>&nbsp;|&nbsp; -->
                        <router-link :to="`/corrective-actions/complete/${data.item.corrective_action_id}`" class="btn btn-sm btn-light">
                            <i class="fa fa-flag-checkered"></i> Complete
                        </router-link>
                    </span>
                </template>
                <template v-slot:cell(status_name)="data">
                    <span :class="`badge badge-${data.item.status_color}`">{{ data.item.status_name }}</span>
                </template>
                <template v-slot:cell(asset_name)="data">
                    <router-link :to="`/corrective-actions/view/${data.item.corrective_action_id}`">
                        {{ data.item.asset_name }}
                    </router-link>
                </template>
                <template v-slot:cell(creator_first_name)="data">
                    <user-name :user="creator(data.item)" v-if="data.item.creator_id" />
                    <employee-name
                        :employee="{EmployeeId: data.item.creator_employee_id, FirstName: data.item.creator_first_name, LastName: data.item.creator_last_name, EmployeeNumber: data.item.creator_employee_nbr}"
                        v-if="data.item.creator_employee_id" />
                </template>
                <template v-slot:cell(assignee_first_name)="data">
                    <user-name :user="assignee(data.item)" />
                </template>
                <template v-slot:cell(other_assignees)="data">
                    <span v-for="(assign, i) in data.item.other_assignees">
                        <template v-if="i > 0">, </template>{{ assign.FirstName }} {{ assign.LastName }}
                    </span>
                </template>
            </b-table>

            <template v-for="action in actions" v-if="view == 'cards'">
                <b-card class="mb-2" v-if="action">
                    <template slot="header">
                        <div class="d-print-none">
                            <div v-if="!hideActions">
                                <router-link :to="`/corrective-actions/view/${action.corrective_action_id}`" class="mr-3" title="View Corrective Action">
                                    CA-{{ action.corrective_action_id }}
                                </router-link>
                                <router-link :to="`/corrective-actions/view/${action.corrective_action_id}`" class="btn btn-sm btn-light" title="View Corrective Action">
                                    View
                                </router-link>

                                <template v-if="canEditAction(action)">
                                    <router-link :to="`/corrective-actions/edit/${action.corrective_action_id}`" class="btn btn-sm btn-light" title="Edit Corrective Action">
                                        <i class="fa fa-edit"></i> Edit
                                    </router-link>
                                    <router-link :to="`/corrective-actions/complete/${action.corrective_action_id}`" class="btn btn-sm btn-light" title="Complete Corrective Action">
                                        <i class="fa fa-flag-checkered"></i> Complete
                                    </router-link>
                                    <router-link :to="`/corrective-actions/delete/${action.corrective_action_id}`" class="btn btn-sm btn-light" title="Delete Corrective Action">
                                        <i class="fa fa-trash"></i> Delete
                                    </router-link>
                                </template>
                            </div>

                            <div v-if="showModalEdit">
                                <button v-on:click="emitEditAction(action)" class="btn btn-sm btn-light"><i class="fa fa-edit"></i> Edit</button>
                                <button v-on:click="emitDeleteAction(action)" class="btn btn-sm btn-light"><i class="fa fa-trash"></i> Delete</button>
                            </div>
                        </div>
                        <div class="d-none d-print-block">
                            CA-{{ action.corrective_action_id }}
                        </div>
                    </template>
                    <div class="row">
                        <div class="col-xl-5 col-lg-6 col-12">
                            <div class="d-print-none mb-1">
                                <span class="text-muted d-sm-inline-block d-xs-block">Status:</span>
                                <span :class="`badge badge-${action.status_color}`">{{ action.status_name }}</span>
                            </div>
                            <div class="d-none d-print-block mb-1">
                                <span class="text-muted d-sm-inline-block d-xs-block">Status:</span>
                                <span :class="`text-${action.status_color}`">{{ action.status_name }}</span>
                            </div>
                            <div class="mb-1" v-if="action.source_name">
                                <span class="text-muted d-sm-inline-block d-xs-block">Source:</span>
                                <span>{{ action.source_name }}</span>
                            </div>
                            <div class="mb-1">
                                <span class="text-muted d-sm-inline-block d-xs-block">Location:</span>
                                <span>{{ action.location }}</span>
                            </div>
                            <div class="mb-1">
                                <span class="text-muted d-sm-inline-block d-xs-block">Created By:</span>
                                <span><user-name :user="creator(action)" /></span>
                            </div>
                            <div class="mb-1">
                                <span class="text-muted d-sm-inline-block d-xs-block">Assigned To:</span>
                                <span><user-name :user="assignee(action)" /></span>
                            </div>
                            <div class="mb-1" v-if="action.other_assignees && action.other_assignees.length > 0">
                                <span class="text-muted d-sm-inline-block d-xs-block">Other Assignees:</span>
                                <span v-for="(assign, i) in action.other_assignees">
                                    <template v-if="i > 0">, </template>{{ assign.FirstName }} {{ assign.LastName }}
                                </span>
                            </div>
                            <div class="mb-1" v-if="action.subcontractor_id || action.subcontractor">
                                <span class="text-muted d-sm-inline-block d-xs-block">Subcontractor:</span>
                                <router-link :to="`/subcontractors/view/${action.subcontractor_id}`" v-if="action.subcontractor_id">{{ action.subcontractor_name }}</router-link>
                                <span v-else-if="action.subcontractor">{{ action.subcontractor }}</span>
                            </div>
                            <div class="mb-1" v-if="action.completed_by || action.completed_by_employee_id">
                                <span class="text-muted d-sm-inline-block d-xs-block">Completed By:</span>
                                <span>
                                    <user-name :user="completer(action)" v-if="action.completed_by" />
                                    <employee-name
                                        :employee="{EmployeeId: action.completed_by_employee_id, FirstName: action.completer_first_name, LastName: action.completer_last_name, EmployeeNumber: action.completer_employee_nbr}"
                                        v-else-if="action.completed_by_employee_id" />
                                </span>
                            </div>
                            <div class="mb-1">
                                <span class="text-muted d-sm-inline-block d-xs-block">Created Date:</span>
                                <span>{{ action.created_at | moment('timezone', userTimezone, 'MM/DD/YYYY hh:mm a') }}</span>
                            </div>
                            <div class="mb-1">
                                <span class="text-muted d-sm-inline-block d-xs-block">Due Date:</span>
                                <span v-if="action.due_date">{{ action.due_date | moment("MM/DD/YYYY") }}</span>
                            </div>
                            <div class="mb-1">
                                <span class="text-muted d-sm-inline-block d-xs-block">Completed Date:</span>
                                <span v-if="action.completed_at">{{ action.completed_at | moment('timezone', userTimezone, 'MM/DD/YYYY hh:mm a') }}</span>
                            </div>
                            <div class="mb-1" v-if="action.time_to_completion">
                                <span class="text-muted d-sm-inline-block d-xs-block">Time to Completion:</span>
                                <span>{{ action.time_to_completion }}</span>
                            </div>
                        </div>
                        <div class="col-xl-7 col-lg-6 col-12">
                            <div class="mb-3">
                                <label class="text-muted">Details:</label><br>
                                {{ action.detail }}
                            </div>
                            <div>
                                <label class="text-muted">Completed Notes:</label><br>
                                {{ action.completed_detail }}
                            </div>
                        </div>
                    </div>
                    <span class="d-print-none">
                        <hr v-if="(action.new_files && action.new_files > 0) || (action.files && action.files.length > 0)"/>

                        <template v-if="action.new_files && action.new_files > 0">
                            <div v-for="file in action.new_files">
                                <!-- file = {name: "some-name", lastModified: 156278989, size: 29878, type: "image/png", webkitRelativePath: ""} -->
                                {{ file.name }}
                            </div>
                            <hr/>
                        </template>

                        <template v-if="action.files && action.files.length > 0">
                            <file-list :files="action.files" :displayType="fileDisplayType" :canEdit="canEditAction(action)" :editMode="editMode"></file-list>
                        </template>
                    </span>
                </b-card>
            </template>
        </template>
        <template v-else-if="showEmptyMsg">
            <div class="card" v-if="view == 'cards'">
                <div class="card-body" style="padding: 0.5rem;">
                    -- No Corrective Actions --
                </div>
            </div>
            <p v-else>No Corrective Actions.</p>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            actions: {
                type: Array,
                required: true
            },

            view: {
                type: String,
                required: false,
                default: 'table',
            },

            hideActions:  {
                type: Boolean,
                required: false,
                default: false,
            },

            showModalEdit: {
                type: Boolean,
                required: false,
                default: false,
            },

            showEmptyMsg: {
                type: Boolean,
                default: true,
            },

            canEditHelper: {
                type: Boolean,
                default: false,
            },

            editMode: {
                type: Boolean,
                default: false,
            },

            fileDisplayType: {
                type: String,
                default: "list2.0",
            }
        },

        data: function() {
            return {
              userTimezone: this.$store.state.user.timezone,
              actionFields: [
                  {key: 'corrective_action_id', label: 'Actions'},
                  {key: 'status_name', label: 'Status'},
                  {key: 'asset_name', label: 'Attached To'},
                  {key: 'creator_first_name', label: 'Created By'},
                  {key: 'assignee_first_name', label: 'Assigned To'},
                  {key: 'other_assignees', label: 'Other Assignees'}
              ],
            }
        },

        computed: {

        },

        methods: {
            assignee(action) {
                return {
                    FirstName: action.assignee_first_name,
                    LastName: action.assignee_last_name,
                    deleted_at: action.assignee_deleted_at,
                };
            },

            creator(action) {
                return {
                    FirstName: action.creator_first_name,
                    LastName: action.creator_last_name,
                    deleted_at: action.creator_deleted_at,
                };
            },

            completer(action) {
                return {
                    FirstName: action.completer_first_name,
                    LastName: action.completer_last_name,
                    deleted_at: action.completer_deleted_at,
                };
            },

            emitEditAction(action){
                //Emit it
                this.$emit('editAction', action);
            },

            emitDeleteAction(action){
                //Emit it
                this.$emit('deleteAction', action);
            },

            canEditAction(action){
                //Check manager permission
                if(this.$root.hasPermission('correctiveActions.manage'))
                {
                    return true;
                }

                //Check Helper
                if(this.canEditHelper)
                {
                    return true;
                }

                //Check manager permission
                if(action.assignee_id == this.$store.state.user.UserId || action.creator_id == this.$store.state.user.UserId)
                {
                    return true;
                }

                //Check other Assignees
                if(Array.isArray(action.other_assignees) && action.other_assignees.length > 0)
                {
                    //Loop and Chekc
                    for (var i = 0; i < action.other_assignees.length; i++)
                    {
                        //Check ID
                        if(action.other_assignees[i].UserId == this.$store.state.user.UserId)
                        {
                            return true;
                        }
                    }
                }

                //Default
                return false;
            },
        },

        mounted() {
            //Get the incidents
            //this.getClient();
        }
    }
</script>